export default __webpack_public_path__ + "static/media/IntegrationChatGPT.35d73a96.jpg";